import { Space, Skeleton } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';

import styles from './RightPart.module.scss';

export const SkeletonCard = () => {
  const isMobile = useIsMobile();

  return (
    <Space
      size={16}
      className={styles.card}
      align="center"
      direction={isMobile ? 'vertical' : 'horizontal'}
    >
      <Space size={12}>
        <Space
          align="center"
          size={16}
        >
          <Skeleton.Avatar />
          <Skeleton.Paragraph className={cn(styles.h16, styles.bankName)} />
        </Space>
        {!isMobile && (
          <>
            <Space
              direction="vertical"
              size={8}
            >
              <Skeleton.Paragraph
                className={styles.h12}
                width={75}
              />
              <Skeleton.Paragraph />
            </Space>
            <Space
              direction="vertical"
              size={8}
            >
              <Skeleton.Paragraph
                className={styles.h12}
                width={90}
              />
              <Skeleton.Paragraph />
            </Space>
          </>
        )}
        <Skeleton.Button className={styles.h52} />
      </Space>
      {isMobile && (
        <Space size={16}>
          <Space
            direction="vertical"
            size={8}
          >
            <Skeleton.Paragraph
              className={styles.h12}
              width={75}
            />
            <Skeleton.Paragraph />
          </Space>
          <Space
            direction="vertical"
            size={8}
          >
            <Skeleton.Paragraph
              className={styles.h12}
              width={90}
            />
            <Skeleton.Paragraph />
          </Space>
        </Space>
      )}
    </Space>
  );
};
